import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ArrowLeft, Droplet, Music, HandHeart, Bus } from 'lucide-react';
export function SaintLuciaPage() {
  return <div className="min-h-screen font-sans" style={{
    backgroundColor: '#0D121D'
  }} data-id="element-551" data-mp="3m460gvtp7xw">
      <Header data-id="element-552" data-mp="3usnh7x5kmzwq" />

      <main className="pt-32 pb-24 min-h-screen" data-id="element-553" data-mp="3ut6wf63u7a72">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-554" data-mp="vcqolhpt2j9o">
          <a href="/" className="inline-flex items-center text-slate-300 hover:text-white transition-colors mb-12" data-id="element-555" data-mp="v9w6vxy6fcjy">
            <ArrowLeft className="w-5 h-5 mr-2" data-id="element-556" data-mp="maheuu2d2txc" />
            Back to Home
          </a>

          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-557" data-mp="hd90z5o8xc1w">
            <div className="mb-12 flex justify-center" data-id="element-558" data-mp="371rs57si2it6">
              <img src="https://cdn.magicpatterns.com/uploads/4dYKVGJtaJWfxh4NtZTznB/Twice_Bourne_holdings_White_text.png" alt="TwiceBourne Holdings LTD Logo" className="max-w-md w-full h-auto" data-id="element-559" data-mp="373cmawawjzqi" />
            </div>

            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-560" data-mp="1bnin27nysu2p">
              TwiceBourne Holdings LTD
            </h1>
            <p className="text-xl text-slate-300" data-id="element-561" data-mp="xoiyt14d6h72">
              Building prosperity in Saint Lucia through diverse ventures
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-562" data-mp="nypmtz0b802a">
            {/* Buy Natural Honey */}
            <a href="/honey" className="group bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-amber-400/50 transition-colors p-8 flex flex-col" data-id="element-563" data-mp="spxv2rpwlfdv">
              <div className="w-12 h-12 rounded-full bg-amber-400/20 flex items-center justify-center mb-6 text-amber-300" data-id="element-564" data-mp="jy5sf374faju">
                <Droplet className="w-6 h-6" data-id="element-565" data-mp="526lhvvqzgga" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3 group-hover:text-amber-300 transition-colors" data-id="element-566" data-mp="9y5412uea48s">
                Buy Natural Honey Produced in Saint Lucia
              </h3>
              <p className="text-slate-300 flex-grow mb-4" data-id="element-567" data-mp="3i8z80z3100eu">
                Pure, raw honey harvested from our own apiaries in Saint Lucia.
                Bottled with care and ready for delivery to your doorstep.
              </p>
              <span className="text-sm text-amber-300 font-medium" data-id="element-568" data-mp="38cmf43fb1ql5">
                Learn More →
              </span>
            </a>

            {/* Artist Launch - Honorable Music */}
            <a href="/honorable-music" className="group bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-slate-500 transition-colors p-8 flex flex-col" data-id="element-569" data-mp="4vnt3nsazs41">
              <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center mb-6 text-white" data-id="element-570" data-mp="3r3negskc7o58">
                <Music className="w-6 h-6" data-id="element-571" data-mp="2kj4e728b87tk" />
              </div>
              <div className="inline-block px-3 py-1 rounded-full bg-green-600/20 text-green-400 text-xs font-medium mb-3 self-start" data-id="element-572" data-mp="2fkugajv7at49">
                Artist Launch
              </div>
              <h3 className="text-xl font-bold text-white mb-3 group-hover:text-green-400 transition-colors" data-id="element-573" data-mp="104hk9wl88i0s">
                Honorable Music
              </h3>
              <p className="text-slate-300 flex-grow mb-4" data-id="element-574" data-mp="19szji9duyh2b">
                New Soca Artist from Saint Lucia. Start a vibe and book a
                performance with two hit singles making waves.
              </p>
              <span className="text-sm text-green-400 font-medium" data-id="element-575" data-mp="1iteg44w9vil4">
                Explore the Artist →
              </span>
            </a>

            {/* Anse Canot Community Outreach Foundation */}
            <a href="/anse-canot" className="group bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-emerald-400/50 transition-colors p-8 flex flex-col" data-id="element-576" data-mp="1ssdi54mj8fz5">
              <div className="w-12 h-12 rounded-full bg-emerald-400/20 flex items-center justify-center mb-6 text-emerald-300" data-id="element-577" data-mp="3uk9toe8p9ptx">
                <HandHeart className="w-6 h-6" data-id="element-578" data-mp="1oxapjw6kr3js" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3 group-hover:text-emerald-300 transition-colors" data-id="element-579" data-mp="1jvbo4rueagph">
                Anse Canot Community Outreach Foundation
              </h3>
              <p className="text-slate-300 flex-grow mb-4" data-id="element-580" data-mp="1tvc9ejbtr6wb">
                Empowering kids in our community with technology and digital
                skills to build brighter futures.
              </p>
              <span className="text-sm text-emerald-300 font-medium" data-id="element-581" data-mp="116omkjbfg9gn">
                Learn More →
              </span>
            </a>

            {/* Scheduled Bus Route Service - Coming Soon */}
            <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 p-8 flex flex-col opacity-70" data-id="element-582" data-mp="1a58t6m3pqsoi">
              <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center mb-6 text-white" data-id="element-583" data-mp="mewgkxxiw7rl">
                <Bus className="w-6 h-6" data-id="element-584" data-mp="idb6tlgac9lm" />
              </div>
              <div className="inline-block px-3 py-1 rounded-full bg-slate-700/50 text-slate-400 text-xs font-medium mb-3 self-start" data-id="element-585" data-mp="8afcjs75713j">
                Coming Soon
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-586" data-mp="3uj6vgdcc34xn">
                Scheduled Bus Route Service
              </h3>
              <p className="text-slate-300 flex-grow" data-id="element-587" data-mp="3cm3mregfszk">
                Reliable transportation across Saint Lucia. Scheduled bus routes
                for daily commuters, camps, churches, schools and events.
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-588" data-mp="h2pnxctrxcmd" />
    </div>;
}